<div style="background: #161616;">
  <div class="flex justify-end close-icon">
    <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color" style="cursor: pointer;" (click)="cancel()">
      close
    </mat-icon>
  </div>
  <!-- <div class="back-holder" routerLink="/profile">
    <div class="back">
      <mat-icon style="margin-right: 4px; color: #29314A">keyboard_backspace</mat-icon>
    </div>
    <span style="margin-right: 5px; outline: none; color: #29314A;  font-size: 14px">Go back to profile</span>
  </div> -->


  <div>
    <div class="flex justify-center">
      <div style="display: flex; flex-direction: column;margin:0 auto;" class="text-center">
        <div class="head-img">
          <div style="width: 100px; height: 100px;margin: 0 auto;  border-radius: 100px" (click)="chooseImage()"
            (change)="fileSelect($event)" class="head_image">
            <div class="fz_16 fc_DEDEDE edit_none">EDIT</div>
            <img *ngIf="user && user.headerUrl" src="{{SERVER_URL}}images{{user.headerUrl}}"
              style="width: 100%; height: 100%;border-radius: 50%;">
            <img src="./assets/images/default-user.svg" class="head-img" *ngIf="!user || !user.headerUrl">
            <!-- <div class="upload_avatar flex align-center justify-center" *ngIf="!user || !user.headerUrl">
              上传头像</div> -->
          </div>
          <input type="file" accept="image/jpeg,image/jpg,image/png,image/svg" (change)="fileSelect($event)"
            class="mt_10" id="img-upload">
        </div>


        <!-- <div style="width: 100px; height: 100px;margin: 0 auto;" *ngIf="user && user.headerUrl">
              <img src="{{SERVER_URL}}images{{user.headerUrl}}"
                  style="width: 100%; height: 100%;  border-radius: 100px">
          </div>
          <input type="file" accept="image/jpeg,image/jpg,image/png,image/svg" (change)="fileSelect($event)"
              class="mt_10">
          <button mat-button
              style="background: #161616; color: #DEDEDE; width: fit-content; margin-top: 10px;border: 1px solid #DEDEDE;"
              (click)="uploadAvatar()">Upload
          </button> -->
      </div>
    </div>

    <form [formGroup]="reactiveForm" class="edit_container">
      <div style="display: flex; justify-content: space-between">
        <mat-form-field style="width: 45%" appearance="outline">
          <mat-label>First name</mat-label>
          <input matInput formControlName="firstName">
        </mat-form-field>
        <mat-form-field style="width: 45%" appearance="outline">
          <mat-label>Last name</mat-label>
          <input matInput formControlName="lastName">
        </mat-form-field>
      </div>
      <mat-form-field style="width: 100%" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" [disabled]="true">
      </mat-form-field>
      <mat-form-field style="width: 100%" appearance="outline">
        <mat-label>Phone Number</mat-label>
        <input matInput formControlName="phone">
      </mat-form-field>
      <mat-form-field style="width: 100%" appearance="outline">
        <mat-label>Role</mat-label>
        <mat-select formControlName="role">
          <mat-option [value]=3>Developer admin</mat-option>
          <mat-option [value]=4>Developer manager</mat-option>
          <mat-option [value]=5>Developer operator</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 100%" appearance="outline">
        <mat-label>Password</mat-label>
        <input matInput formControlName="password">
      </mat-form-field>

      <div style="display: flex; justify-content: flex-end">
        <button mat-button (click)="editUser()" class="update_button">
          Update
        </button>
      </div>


    </form>

  </div>

</div>